import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  FiChevronRight,
  FiHome,
  FiArrowUpRight,
  FiArrowDownLeft,
} from "react-icons/fi";

import { getMyFundTransfers } from "../../store/slices/fund";

const FundTransferList = () => {
  const dispatch = useDispatch();

  const {
    fundTransfers = [],
    fundTransfersLoading,
    fundTransfersError,
  } = useSelector((state) => state.fund);

  useEffect(() => {
    dispatch(getMyFundTransfers());
  }, [dispatch]);

  const formatDate = (date) => {
    if (!date) return "-";

    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      return "-";
    }

    return parsedDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatTime = (date) => {
    if (!date) return "";

    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      return "";
    }

    return parsedDate.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const formatAmount = (amount) => {
    if (amount === null || amount === undefined) {
      return "0.00";
    }

    const numericAmount = Number(amount);

    if (isNaN(numericAmount)) {
      return "0.00";
    }

    return numericAmount.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div className="gi-referral-page">
      {/* Breadcrumb */}
      <div className="gi-breadcrumb">
        <Link to="/dashboard">
          <FiHome />
          Dashboard
        </Link>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>Fund Transfer</span>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>Transfer List</span>
      </div>

      {/* Table */}
      <section className="gi-referral-table-card">
        <div className="gi-referral-table-wrapper">
          <table className="gi-referral-table">
            <thead>
              <tr>
                <th>#</th>

                <th className="text-center">
                  Member
                </th>

                <th className="text-center">
                  User ID
                </th>

                <th className="text-center">
                  Amount
                </th>

                <th className="text-center">
                  Type
                </th>

                <th className="text-center">
                  Status
                </th>

                <th className="text-center">
                  Date
                </th>
              </tr>
            </thead>

            <tbody>
              {/* Loading */}
              {fundTransfersLoading && (
                <tr>
                  <td
                    colSpan="7"
                    className="gi-table-message"
                  >
                    Loading fund transfers...
                  </td>
                </tr>
              )}

              {/* Error */}
              {!fundTransfersLoading &&
                fundTransfersError && (
                  <tr>
                    <td
                      colSpan="7"
                      className="gi-table-message"
                    >
                      {fundTransfersError}
                    </td>
                  </tr>
                )}

              {/* Empty */}
              {!fundTransfersLoading &&
                !fundTransfersError &&
                fundTransfers.length === 0 && (
                  <tr>
                    <td
                      colSpan="7"
                      className="gi-table-message"
                    >
                      No fund transfers found
                    </td>
                  </tr>
                )}

              {/* Data */}
              {!fundTransfersLoading &&
                !fundTransfersError &&
                fundTransfers.map((item, index) => {
                  const type = String(
                    item.type || ""
                  ).toUpperCase();

                  const transactionType = String(
                    item.transactionType || ""
                  ).toUpperCase();

                  /*
                   * RECEIVED:
                   *   member = receivedFrom
                   *
                   * SENT:
                   *   member = sentTo
                   */
                  const member =
                    type === "RECEIVED"
                      ? item.receivedFrom
                      : item.sentTo;

                  /*
                   * SENT = money going out
                   * RECEIVED = money coming in
                   */
                  const isDebit = type === "SENT";

                  return (
                    <tr
                      key={
                        item._id || index
                      }
                    >
                      {/* Number */}
                      <td className="text-center gi-referral-number">
                        {String(index + 1).padStart(
                          2,
                          "0"
                        )}
                      </td>

                      {/* Member Name */}
                      <td className="text-center">
                        <strong>
                          {member?.name || "-"}
                        </strong>
                      </td>

                      {/* User ID */}
                      <td className="text-center">
                        <span className="gi-user-id">
                          {member?.userId || "-"}
                        </span>
                      </td>

                      {/* Amount */}
                      <td className="text-center">
                        <span
                          className={`gi-transfer-amount ${isDebit
                            ? "debit"
                            : "credit"
                            }`}
                        >
                          {isDebit ? (
                            <FiArrowUpRight />
                          ) : (
                            <FiArrowDownLeft />
                          )}

                          {isDebit ? "-" : "+"}

                          {formatAmount(
                            item.amount
                          )}
                        </span>
                      </td>

                      {/* Type */}
                      <td className="text-center">
                        <span>
                          {type || "-"}
                        </span>
                      </td>

                      {/* Status */}
                      <td className="text-center">
                        <span
                          className={`gi-status ${String(
                            item.status || ""
                          ).toLowerCase()}`}
                        >
                          {item.status || "-"}
                        </span>
                      </td>

                      {/* Date */}
                      <td className="text-center">
                        <div className="gi-date-cell">
                          <span className="gi-date-text">
                            {formatDate(
                              item.createdAt
                            )}
                            ,{" "}
                            {formatTime(
                              item.createdAt
                            )}
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default FundTransferList;
